import {
  Color,
  NormalBlending,
  RawShaderMaterial,
  BufferAttribute,
  BufferGeometry,
  Points
} from 'three';

export class PointCloud {

    static getShader({blending = NormalBlending}){

      let uniforms = {
        color: {
          value: new Color(0xffffff)
        }
      };

      return new RawShaderMaterial({
        uniforms: uniforms,
        vertexShader: `
          precision highp float;
    
          uniform mat4 modelViewMatrix;
          uniform mat4 projectionMatrix;
    
          attribute vec3 position;
    
          attribute float size;
          attribute vec3 customColor;
          attribute float alpha;
    
          varying float vAlpha;
          varying vec3 vColor;
    
          void main() {
            vColor = customColor;
            vAlpha = alpha;
            vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
            gl_PointSize = size * ( 300.0 / -mvPosition.z );
            gl_Position = projectionMatrix * mvPosition;
          }`,
        fragmentShader: `
          precision highp float;
          uniform vec3 color;
    
          varying vec3 vColor;
          varying float vAlpha;
    
          void main() {
            gl_FragColor = vec4( color * vColor, vAlpha );
            gl_FragColor = gl_FragColor;
          }`,
    
        blending: blending,
        depthTest: true,
        transparent: true
    
      });
    }

    constructor(){
      this.loaded = false;
    }

    load(positions, colors, sizes, alphas, shader){
  
      this.positions = positions;
      this.colors = colors;
      this.sizes = sizes;
      this.alphas = alphas;
  
      this.geometry = new BufferGeometry();
  
      this.geometry.setAttribute('position', new BufferAttribute(positions, 3));
      this.geometry.setAttribute('customColor', new BufferAttribute(colors, 3));
      this.geometry.setAttribute('size', new BufferAttribute(sizes, 1));
      this.geometry.setAttribute('alpha', new BufferAttribute(alphas, 1));

      this.points = new Points(this.geometry, shader);
  
    }
  
    add(scene){
      scene.add(this.points);
    }
  
    remove(scene){
      scene.remove(this.points);
    }
  
  }